import { render, staticRenderFns } from "./feedback-info.vue?vue&type=template&id=09010e56&scoped=true&"
import script from "./feedback-info.vue?vue&type=script&lang=js&"
export * from "./feedback-info.vue?vue&type=script&lang=js&"
import style0 from "./feedback-info.vue?vue&type=style&index=0&id=09010e56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09010e56",
  null
  
)

export default component.exports